const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export default onlyUnique;
